export type IconButtonProps = {
  children: React.ReactNode;
  onClick?: (...args: any[]) => void;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  color?: "default" | "primary" | "secondary";
  className?: string;
  ariaLabel?: string;
  variant?: "default" | "bare";
};

const sizeClasses = {
  small: "w-8 h-8",
  medium: "w-10 h-10",
  large: "w-12 h-12",
};

const colorClasses = {
  default:
    "text-gray-700 hover:bg-gray-200 focus-visible:ring-gray-400",
  primary:
    "text-blue-600 hover:bg-blue-100 focus-visible:ring-blue-500",
  secondary:
    "text-description hover:bg-gray-100 focus-visible:ring-gray-500",
};

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  disabled = false,
  size = "medium",
  color = "default",
  className = "",
  ariaLabel = "Button",
  variant = "default",
}) => {
  const isBare = variant === "bare";

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center
        cursor-pointer transition-colors duration-200
        focus:outline-none
        ${isBare ? "" : "rounded-full focus-visible:ring-2 focus-visible:ring-offset-2"}
        ${isBare ? "" : sizeClasses[size]}
        ${isBare ? "" : colorClasses[color]}
        ${disabled ? "opacity-40 cursor-not-allowed hover:bg-transparent" : ""}
        ${className}
      `}
    >
      {children}
    </button>
  );
};
